import { api } from './api'
import { CommunicationLog, CommunicationLogFormData } from '../types/communicationLog'

export const communicationLogService = {
  /**
   * Get all communication logs
   */
  getAll: async (): Promise<CommunicationLog[]> => {
    const response = await api.get<CommunicationLog[]>('/communication-logs')
    return response.data
  },

  /**
   * Get communication log by ID
   */
  getById: async (id: string): Promise<CommunicationLog> => {
    const response = await api.get<CommunicationLog>(`/communication-logs/${id}`)
    return response.data
  },

  /**
   * Get communication logs for a specific patient
   */
  getByPatient: async (patientId: string): Promise<CommunicationLog[]> => {
    const response = await api.get<CommunicationLog[]>('/communication-logs', {
      params: { patientId },
    })
    return response.data
  },

  /**
   * Get communication logs linked to a task
   */
  getByTask: async (taskId: string): Promise<CommunicationLog[]> => {
    const response = await api.get<CommunicationLog[]>('/communication-logs', {
      params: { taskId },
    })
    return response.data
  },

  /**
   * Create a new communication log
   */
  create: async (data: CommunicationLogFormData): Promise<CommunicationLog> => {
    const response = await api.post<CommunicationLog>('/communication-logs', data)
    return response.data
  },

  /**
   * Update a communication log
   */
  update: async (id: string, data: Partial<CommunicationLogFormData>): Promise<CommunicationLog> => {
    const response = await api.put<CommunicationLog>(`/communication-logs/${id}`, data)
    return response.data
  },

  /**
   * Delete a communication log
   */
  delete: async (id: string): Promise<void> => {
    await api.delete(`/communication-logs/${id}`)
  },
}

